<div class="popup-window" [ngClass]="{ 'p-show': visible }">
    <div class="p-header">
      {{ title }}
    </div>
    <div class="p-footer">
      <button class="ui button mini" (click)="onOK()">OK</button>
      <button class="ui button mini" (click)="onCancel()">Cancel</button>
    </div>
  </div>
